import { c as _c } from "react/compiler-runtime";
import { Badge, Button, ButtonGroup } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React, { ReactNode } from 'react';
type PaywallTermSelectorProps = {
  terms: Array<{
    discountBadge?: ReactNode | string;
    id: string;
    title: string;
  }>;
  value?: string;
  onChange: (termId: string) => void;
};
export const PaywallTermSelector = props => {
  const $ = _c(7);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue(["vertical", "vertical", "horizontal"]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = props.terms.map((term, idx) => <Button key={idx} bgColor={props.value !== term.id ? "transparent" : "colorPalette.emphasized"} flex={1} padding="1em" transition="all 100ms ease-out" variant="outline" _hover={{
      borderWidth: "1px",
      bgColor: props.value !== term.id ? "colorPalette.subtle/50" : null
    }} onClick={() => props.onChange(term.id)}>{term.title}{term.discountBadge ? <Badge bgColor="colorPalette.solid" fontSize="xs" paddingX={2}>{term.discountBadge}</Badge> : null}</Button>);
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <ButtonGroup align="stretch" attached={true} maxWidth="800px" orientation={t0} variant="outline" width="full">{t1}</ButtonGroup>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};